module.exports = __webpack_public_path__ + "static/school-42fc05ac4f3b8cb6e9c7dddd1cc34cc3.png";